import React from 'react'
import Grid, { Grid2Props } from '@mui/material/Grid2'

interface MetricsGridProps extends Grid2Props {
  noOfColumns: 2 | 3 | 4
  columns: React.ReactNode[]
  isStatic?: boolean
}

const MetricsGrid = ({
  noOfColumns = 3,
  columns,
  isStatic = false,
  ...props
}: MetricsGridProps) => {
  const calculateSize = () => {
    if (noOfColumns === 2) return { xs: isStatic ? 6 : 12, md: 6 }
    if (noOfColumns === 3) return { xs: isStatic ? 4 : 12, md: 4 }
    if (noOfColumns === 4) return { xs: isStatic ? 3 : 12, md: 3 }
    return { xs: isStatic ? 4 : 12, md: 4 }
  }

  return (
    <Grid container {...props}>
      {columns.map((column, index) => (
        <Grid key={index} size={calculateSize()}>
          {column}
        </Grid>
      ))}
    </Grid>
  )
}

export default MetricsGrid
